export default "__VITE_ASSET__k$vJFjVc__"